import { Outlet, Routes, Route, Navigate } from 'react-router-dom'
import Header from './components/Header'
import Traceability from './pages/Traceability'
import Appreciation from './pages/Appreciation'
import Exploration from './pages/Exploration'
import RhymeTasting from './pages/RhymeTasting'
import Footer from './components/Footer'
import Immersive from './pages/Immersive'
import ExplorationMolin from './pages/ExplorationMolin'
import MainStreet from './pages/molin/MainStreet'
import MarinaDistrict from './pages/molin/MarinaDistrict'
import RestaurantTreasurePavilion from './pages/molin/RestaurantTreasurePavilion'
import StallTrading from './pages/molin/StallTrading'
import FriendOfXiang from './pages/molin/FriendOfXiang'
import StreetBlock1 from './pages/molin/StreetBlock1'
import StreetBlock2 from './pages/molin/StreetBlock2'
import SubStreet from './pages/molin/SubStreet'
import TianlaiPavilion from './pages/molin/TianlaiPavilion'
import Merchant from './pages/molin/Merchant'
import AppraisalHall from './pages/molin/AppraisalHall'
import NotFound from './components/NotFound'

// 新增布局组件（包含Header和Footer）
function Layout() {
  return (
    <div className="relative">
      <Header />
      <section className="relative">
        <Outlet /> {/* 子路由内容在此渲染 */}
      </section>
      <Footer className="mt-auto relative" />
    </div>
  )
}

function App() {
  return (
    <Routes>
      {/* 需要显示Header/Footer的路由组 */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Traceability />} />
        <Route path="appreciation" element={<Appreciation />} />
        <Route path="/exploration" element={<Exploration />} />
        <Route path="/rhymetasting" element={<RhymeTasting />} />
      </Route>
      {/* 独立路由（不显示Header/Footer） */}
      <Route path="/immersive" element={<Immersive />} />
      <Route path="/explorationmolin" element={<ExplorationMolin />} />
      <Route path="/mainstreet" element={<MainStreet />} />
      <Route path="/marinadistrict" element={<MarinaDistrict />} />
      <Route path="/restauranttreasurepavilion" element={<RestaurantTreasurePavilion />} />
      <Route path="/stalltrading" element={<StallTrading />} />
      <Route path="/friendofxiang" element={<FriendOfXiang />} />
      <Route path="/streetblock2" element={<StreetBlock2 />} />
      <Route path="/substreet" element={<SubStreet />} />
      <Route path="/tianlaipavilion" element={<TianlaiPavilion />} />
      <Route path="/merchant" element={<Merchant />} />
      <Route path="/appraisalhall" element={<AppraisalHall />} />
      <Route path="/streetblock1" element={<StreetBlock1 />} />
      <Route path="/losscat" element={<NotFound />} />
      <Route
        path="*"
        element={
          <Navigate
            to="/losscat"
            replace
            state={{ from: location.pathname }}
          />
        }
      />
    </Routes>
  )
}

export default App